<template>
  <div
    :class="{
      desktop_container: !$vuetify.display.smAndDown,
    }"
  >
    <EditTemplate
      :dialog="template_dialog"
      :template="media[0]"
      @result="
        (r) => {
          media[0].src = r;
          media[0].thumbnail = r;
          template_dialog = false;
        }
      "
    />

    <ConfirmDialog
      text="Are you sure?"
      :dialog="confirm_dialog"
      @confirm="confirmResult"
    />
    <ConfirmDialog
      text="Adding media will remove the link preview. Continue?"
      :dialog="remove_link"
      @confirm="removeLink"
    />
    <SchedulePost
      :dialog="dialog"
      @close="dialog = false"
      @schedule="schedule"
      ref="schedulepost"
    />

    <v-dialog v-model="dialog2" width="500">
      <v-card color="primary">
        <v-card-title class="text-h5 text-white">
          Oops, something's missing..
        </v-card-title>

        <v-card-text class="mt-3 text-white">
          <ul>
            <li v-for="(m, index) in complete.missing" :key="index">
              {{ m }}
            </li>
          </ul>
          <p class="mb-0 mt-4 text-white">
            Or save the post as draft and finish later.
          </p>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="button" @click="dialog2 = false"> Continue </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div
      style="width: 100%; height: 100vh; padding-top: 3vh"
      class="d-flex justify-center"
    >
      <div
        class="post-container d-flex justify-center"
        style="width: 80%; min-width: 500px"
      >
        <div>
          <div
            class="d-flex align-center justify-space-between mb-2"
            style="gap: 5px"
          >
            <div class="d-flex align-center" style="gap: 5px">
              <v-btn
                size="small"
                variant="text"
                icon="mdi-arrow-left"
                @click="$router.go(-1)"
              ></v-btn>
              <h1>New Post</h1>
              <div>
                <v-chip
                  class="font-weight-regular"
                  v-if="schedule_date && workspace"
                  >Scheduled
                  {{ formatDate(schedule_date) }}
                  <v-tooltip right color="primary" max-width="250">
                    <template v-slot:activator="{ props }">
                      <v-btn
                        class="ml-2"
                        size="small"
                        @click="
                          dialog = true;
                          changing_schedule = true;
                        "
                        v-bind="props"
                        icon
                      >
                        <v-icon size="small" dark> mdi-autorenew </v-icon>
                      </v-btn>
                    </template>
                    <div>
                      <p style="font-size: 12px" class="text-white mb-0">
                        Change the scheduled date
                      </p>
                    </div>
                  </v-tooltip>

                  <v-tooltip right color="primary" max-width="250">
                    <template v-slot:activator="{ props }">
                      <v-btn
                        @click="
                          schedule_date = null;
                          status = 'draft';
                        "
                        v-bind="props"
                        icon
                        size="small"
                      >
                        <v-icon size="small" dark> mdi-delete-outline </v-icon>
                      </v-btn>
                    </template>
                    <div>
                      <p style="font-size: 12px" class="text-white mb-0">
                        Remove the scheduled date
                      </p>
                    </div>
                  </v-tooltip>
                </v-chip>
              </div>
              <v-btn size="small" elevation="0" variant="text" @click="confirm"
                >Clear</v-btn
              >
            </div>

            <div class="d-flex align-center" style="gap: 7px">
              <v-btn
                size="small"
                variant="text"
                @click="
                  post
                    ? add(schedule_date, status)
                    : add(schedule_date, 'draft')
                "
                >Save</v-btn
              >
              <div>
                <v-menu transition="slide-x-transition" bottom offset-x>
                  <template v-slot:activator="{ props }">
                    <div
                      :style="{
                        borderBottom: '3px solid #272727',
                        borderLeft: '1px solid #272727',
                        borderTop: '1px solid #272727',
                        borderRight: '3px solid #272727',
                        borderRadius: '6px',
                      }"
                    >
                      <v-btn
                        :width="$vuetify.display.smAndDown ? ' 48%' : ''"
                        :style="{
                          'font-size': $vuetify.display.smAndDown ? '12px' : '',
                        }"
                        style="min-width: 130px"
                        v-bind="props"
                        color="button"
                        size="small"
                        elevation="0"
                        ><span class="pl-4">Continue</span
                        ><v-icon id="chevron" class="ml-4"
                          >mdi-chevron-down</v-icon
                        >
                      </v-btn>
                    </div>
                  </template>
                  <!-- TODO remove button 2 and 3 if user does not have permissions to publish, add another button 'request publish'  -->
                  <v-list>
                    <!-- IF EXISTING POST -->
                    <div v-if="post">
                      <!-- <v-list-item
                        @click="add(schedule_date, status)"
                        link
                        class="px-4"
                      >
                        <v-list-item-title>Save changes</v-list-item-title>
                      </v-list-item> -->
                      <v-list-item
                        @click="add(null, 'active')"
                        link
                        class="px-4"
                        v-if="!schedule_date && status === 'draft'"
                      >
                        <v-list-item-title
                          >Automatic scheduling</v-list-item-title
                        >
                      </v-list-item>

                      <v-list-item
                        v-if="post && status != 'draft'"
                        link
                        class="px-4"
                        @click="add(null, 'draft')"
                      >
                        <v-list-item-title>Save as draft</v-list-item-title>
                      </v-list-item>

                      <v-list-item
                        v-if="!schedule_date"
                        link
                        class="px-4"
                        @click="add('now', 'active')"
                      >
                        <v-list-item-title>Publish now</v-list-item-title>
                      </v-list-item>
                      <v-list-item link class="px-4" @click="dialog = true">
                        <v-list-item-title>Publish later</v-list-item-title>
                      </v-list-item>
                    </div>

                    <!-- IF NEW -->
                    <div v-else>
                      <v-list-item
                        @click="add(null, 'active')"
                        link
                        class="px-4"
                      >
                        <v-list-item-title
                          >Automatic scheduling</v-list-item-title
                        >
                      </v-list-item>
                      <v-list-item
                        link
                        class="px-4"
                        @click="add('now', 'active')"
                      >
                        <v-list-item-title>Publish now </v-list-item-title>
                      </v-list-item>
                      <v-list-item link class="px-4" @click="dialog = true">
                        <v-list-item-title>Publish later</v-list-item-title>
                      </v-list-item>
                      <!-- <v-list-item link class="px-4" @click="add(null, 'review')">
              <v-list-item-title>Save for review</v-list-item-title>
            </v-list-item> -->
                    </div>
                  </v-list>
                </v-menu>
              </div>
            </div>
          </div>

          <div class="mb-4">
            <v-card
              :style="{
                borderBottom: '3px solid #272727',
                borderLeft: '1px solid #272727',
                borderTop: '1px solid #272727',
                borderRight: '3px solid #272727',
                borderRadius: '10px',
              }"
              flat
              class="align-center pa-2"
              style="
                gap: 5px;
                display: grid;
                grid-template-columns: 1fr 1px 1fr 1px 1fr;
              "
            >
              <v-select
                :items="[
                  { title: 'Recurring', value: true },
                  { title: 'One-time', value: false },
                ]"
                label="Recurring"
                hide-details
                variant="solo"
                return-object
                flat
                v-model="recurring"
                item-title="title"
                density="compact"
                max-width="200"
                min-width="150"
                rounded
                item-value="value"
              ></v-select>
              <v-divider vertical></v-divider>
              <v-select
                :items="categories"
                label="Category"
                hide-details
                variant="solo"
                return-object
                flat
                v-model="category"
                item-title="name"
                density="compact"
                max-width="200"
                min-width="150"
                rounded
                item-value="uid"
              >
                <!-- <template #append-inner>
                  <v-btn size="x-small" variant="text" icon="mdi-plus"></v-btn>
                </template> -->
              </v-select>
              <v-divider vertical></v-divider>
              <v-select
                :items="accounts"
                label="Accounts"
                multiple
                item-title="name"
                item-value="id"
                density="compact"
                hide-details
                variant="solo"
                style="max-width: 250px"
                flat
                v-model="selected_accounts"
              ></v-select>
            </v-card>
          </div>
          <div
            style="display: grid; grid-template-columns: auto 250px; gap: 10px"
          >
            <div
              class="newcontent"
              style="position: relative; z-index: 1; max-width: 500px"
            >
              <div class="mt-4">
                <v-tabs-window v-model="tab">
                  <v-tabs-window-item
                    v-for="(item, index) in variations"
                    :key="index"
                    :value="'tab-' + index"
                  >
                    <linkedinPostEditor
                      v-if="tab !== null && variations && variations[tab]"
                      v-model="variations[tab].text"
                      :disabled="variations[tab] && variations[tab].loading"
                    />
                  </v-tabs-window-item>
                </v-tabs-window>
              </div>
            </div>

            <div style="margin-top: 10px; min-width: 250px">
              <div
                class="bg-white my-2"
                style="width: 100%; padding: 1px"
                :style="{
                  borderBottom: '4px solid #272727',
                  borderLeft: '2px solid #272727',
                  borderTop: '2px solid #272727',
                  borderRight: '4px solid #272727',
                  borderRadius: '7px',
                }"
              >
                <v-sheet
                  class="d-flex justify-center align-center py-1"
                  color="accent"
                  style="
                    font-size: 10pt;
                    font-weight: 600;
                    border-top-right-radius: 4px;
                    border-top-left-radius: 4px;
                  "
                  >Media</v-sheet
                >
                <v-divider></v-divider>
                <v-img
                  v-if="media && media.length === 1 && media[0].type !== 'url'"
                  :src="media[0].src"
                  height="200"
                  width="100%"
                ></v-img>
                <div
                  v-else-if="
                    media && media.length === 2 && media[0].type !== 'url'
                  "
                  style="
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    gap: 4px;
                  "
                >
                  <v-img :src="media[0].src" cover></v-img>
                  <v-img :src="media[1].src"></v-img>
                </div>
                <div
                  v-else-if="media && media.length > 2"
                  style="
                    display: grid;
                    grid-template-columns: 2fr 1fr;
                    gap: 3px;
                  "
                >
                  <v-img :src="media[0].src" cover></v-img>
                  <div class="d-flex flex-column" style="gap: 4px">
                    <v-img :src="media[1].src" cover> </v-img>
                    <v-img :src="media[2].src" cover></v-img>
                  </div>
                </div>
                <div>
                  <!-- <v-btn @click="mentionLookup">test</v-btn> -->
                  <v-list-item
                    class="pa-4"
                    style="color: #7a7a7a; cursor: pointer; font-size: 10pt"
                    v-if="media && media.length === 0"
                    @click="$store.commit('setMediumType', `post`)"
                  >
                    <v-icon left class="mr-1" size="18"
                      >mdi-image-plus-outline</v-icon
                    >
                    Add media
                  </v-list-item>

                  <v-menu
                    v-else-if="media"
                    :close-on-content-click="true"
                    :nudge-width="150"
                    offset-x
                  >
                    <template v-slot:activator="{ props }">
                      <v-list-item
                        class="pa-4"
                        style="color: #7a7a7a; cursor: pointer"
                        v-bind="props"
                      >
                        <v-icon left class="mr-1" size="18"
                          >mdi-image-plus</v-icon
                        >
                        Edit media
                      </v-list-item>
                    </template>

                    <v-card>
                      <v-list dense>
                        <v-list-item
                          v-if="
                            media &&
                            media.length > 0 &&
                            media[0].type === 'template'
                          "
                          density="compact"
                          @click="template_dialog = true"
                          >Edit template
                        </v-list-item>
                        <v-list-item
                          @click="replaceThumbnail"
                          v-if="media[0]?.type === 'url'"
                        >
                          <v-icon size="small" class="mr-2"
                            >mdi-image-plus</v-icon
                          >
                          Replace thumbnail
                        </v-list-item>
                        <v-list-item
                          @click="openMedia"
                          v-if="!media[0]?.type === 'url'"
                        >
                          <v-icon size="small" class="mr-2"
                            >mdi-image-plus</v-icon
                          >
                          Add
                          {{ media[0].type }}
                        </v-list-item>
                        <!-- <v-list-item @click="openMedia">
                        <v-icon size="small" class="mr-2">mdi-sync</v-icon>
                        Replace
                        {{ media[0].type }}
                      </v-list-item> -->
                        <v-list-item dense @click="media = []">
                          <v-icon size="small" class="mr-2">mdi-delete</v-icon>
                          Remove {{ media[0].type
                          }}{{ media.length > 1 ? "s" : "" }}
                        </v-list-item>
                      </v-list>
                    </v-card>
                  </v-menu>
                  <v-divider></v-divider>
                  <div style="width: 100%">
                    <LinkDesktop
                      @preview="setPreview"
                      @open="sheet = true"
                      @close="sheet = false"
                      @remove="
                        link_preview = null;
                        idea = '';
                        sheet = false;
                      "
                      :sheet="sheet"
                      :link_preview="link_preview"
                      :media="media"
                      v-if="
                        (media && media.length === 0) ||
                        media?.[0].type != 'url'
                      "
                    />

                    <div v-else class="pa-4 d-flex align-center">
                      <div
                        style="
                          /* color: #7a7a7a; */
                          overflow: hidden;
                          text-overflow: ellipsis;
                          white-space: nowrap;
                          display: inline-block;
                          cursor: pointer;
                          font-size: 9pt;
                        "
                        @click="openLink(media[0].url)"
                      >
                        <u>{{
                          media[0]?.url?.includes("www.")
                            ? media[0].url.split("www.")[1]
                            : media[0].url
                        }}</u>
                      </div>
                      <div>
                        <v-btn
                          @click="$store.commit('setPostMedia', [])"
                          size="x-small"
                          variant="text"
                          icon="mdi-delete"
                        ></v-btn>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <AskChat
                style="min-width: 200px; width: 275px"
                ref="askChat"
                @anything="askAnything"
                @write="writePost"
                @ideas="$store.commit('setIdeasShow', true)"
                @structures="show_structures = !show_structures"
                :empty="
                  !variations || !variations[tab] || !variations[tab].text
                "
                :idea="idea"
                :instructions="instructions"
              /> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { httpsCallable } from "firebase/functions";
import { functions } from "@/firebase";
import { trackActivation } from "@/utils/analytics";
import SchedulePost from "@/components/SchedulePostDialog.vue";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import { DateTime } from "luxon";
// import AskChat from "@/components/openai/AskChat.vue";
import { post } from "@/mixins/post";
import { languages } from "@/mixins/languages";
import EditTemplate from "@/components/templates/EditTemplate.vue";
import LinkedinPostEditor from "@/components/LinkedinPostEditor.vue";
import LinkDesktop from "@/components/media/LinkDesktop.vue";

export default {
  mixins: [post, languages],
  components: {
    EditTemplate,
    SchedulePost,
    ConfirmDialog,
    // AskChat,
    LinkedinPostEditor,
    LinkDesktop,
  },
  watch: {
    "userProfile.workspace": {
      deep: true,
      async handler() {
        if (this.$route.query.id) {
          this.loadPost(this.$route.query.id);
        }
      },
    },
    media: {
      deep: true,
      async handler() {
        this.changes = true;
      },
    },
    variations: {
      deep: true,
      async handler() {
        this.changes = true;
      },
    },
    link_preview: {
      deep: true,
      async handler() {
        this.changes = true;
      },
    },
  },
  // beforeRouteLeave(to, from, next) {
  // if (!this.saved && this.changes) {
  //   const answer = window.confirm(
  //     "Are you sure you want to leave? Unsaved changes will be lost."
  //   );
  //   if (answer) {
  //     this.clearPost();
  //     next(); // allow navigation
  //   } else {
  //     next(false); // cancel navigation
  //   }
  // } else {
  //   next();
  // }
  // },
  mounted() {
    if (this.$route.query.category) {
      this.category = this.categories.find(
        (c) => c.uid === this.$route.query.category,
      );
    }

    if (this.$route.query.drawer) {
      this.$refs.askChat.write();
    }
    if (this.$route.query.idea) {
      this.idea = this.$route.query.idea;
      this.$refs.askChat.write();
    }
    if (this.$route.query.structure) {
      this.structure = this.$route.query.structure;
      this.$refs.askChat.write();
    }

    if (this.$route.query.scheduled) {
      this.clearPost;
      this.schedule_date = this.$route.query.scheduled;
      const child = this.$refs.schedulepost;
      const dateTime = DateTime.fromMillis(this.$route.query.scheduled * 1000);
      child.setPicker({
        date: dateTime.toFormat("yyyy-MM-dd"),
        hour: dateTime.toFormat("HH"),
        minutes: dateTime.toFormat("mm"),
      });
    }
    if (
      this.$route.query.id &&
      this.userProfile &&
      this.userProfile.workspace
    ) {
      this.loadPost(this.$route.query.id);
    }
  },
  data() {
    return {
      alt: 1,
      attrs: {
        class: "mb-6",
        boilerplate: true,
        elevation: 0,
        outlined: true,
        width: "500px",
      },
      assistant: false,
      chatGPT: false,
      changes: false,
      chatgpt_modus: null,
      changing_schedule: false,
      complete: {
        pass: false,
        missing: [],
      },
      confirm_dialog: false,
      dialog2: false,
      image: "",
      menu: false,
      link_step: 0,
      preview: "linkedin",
      preview_loading: false,
      prompt: "",
      remove_link: false,
      saved: false,
      search: "",
      sheet: false,
      show_structures: false,
      translating: false,
      ideas_drawer: false,
    };
  },
  computed: {
    ...mapState({
      userProfile: (state) => state.users.userProfile,
      loading: (state) => state.loading.general,
      accounts: (state) => state.accounts.accounts,
      categories: (state) => state.posts.categories,
      posts: (state) => state.posts.posts,
      workspace: (state) => state.workspace.workspace,
    }),
    preview_message() {
      if (
        this.variations &&
        this.variations[this.tab] &&
        this.variations[this.tab].text
      ) {
        const m = this.variations[this.tab].text.replace(/\n/g, "<br />");
        return m;
      }
      return "";
    },
    selected_accounts_full() {
      let a = this.selected_accounts;
      a = a.map((a) => {
        return this.accounts.find((acc) => acc.id === a);
      });

      return a;
    },
  },
  methods: {
    replaceThumbnail() {
      console.log("replace thumbnail");
      this.$store.commit("setPostReplaceThumbnail", true);
      this.$store.commit("setMediumType", "post");
    },
    openLink(url) {
      window.open(url, "_blank");
    },
    async mentionLookup() {
      const mentionLookup = httpsCallable(functions, "mentionLookup");
      const res = await mentionLookup();
      console.log(res.data);
    },
    async add(date, status) {
      const complete = await this.checkPost();
      if (!complete.pass && status != "draft") {
        this.dialog2 = true;
        return;
      }

      if (date === "now") {
        date = DateTime.now().toSeconds();
        // date = {
        //   day: dt.day,
        //   month: dt.month,
        //   year: dt.year,
        //   hour: dt.hour,
        //   minutes: dt.minute,
        // };
      }

      this.$store.commit("setLoading", { type: "general", val: true });
      let post = {
        auto_variation: true,
        auto_variation_level: "medium",
        accounts: this.selected_accounts,
        category: this.category ? this.category.uid : null,
        created: Math.floor(Date.now() / 1000),
        created_by: this.userProfile.uid,
        created_by_email: this.userProfile.email,
        recurring: this.recurring,
        last_publish: null,
        scheduled: date != null,
        schedule_date: date ? date : null,
        status: status,
        media: this.media,
        comment: this.comment,
        workspace: this.userProfile.workspace,
        variations: this.variations,
        uid: this.post ? this.post : null,
        timezone: this.workspace.timezone,
      };

      if (this.post) {
        // IF EXISTING POST, THEN UPDATE THE POST
        const updatePost = httpsCallable(functions, "postUpdate");
        await updatePost(post);

        this.$store.dispatch("refreshPost", this.post);

        this.$store.commit("setNotification", {
          show: true,
          text: "Your post has been updated!",
          type: "primary",
        });
      } else {
        // IF NEW POST, ADD POST TO DB
        const addPost = httpsCallable(functions, "postAdd");
        const result = await addPost(post);

        // Track activation event for first post
        if (result && result.data) {
          trackActivation(this.userProfile.uid, result.data, "post");
        }

        this.$store.dispatch("fetchPosts");
        this.$store.commit("setNotification", {
          show: true,
          text: "Your post has been added!",
          type: "primary",
        });
      }
      this.saved = true;
      this.$store.dispatch("getCalendarDays");
      this.$store.dispatch("fetchMedia");
      this.$store.dispatch("clearPost");
      this.$router.push("/library/posts");
      this.$store.commit("setLoading", { type: "general", val: false });
      trackActivation("new_post_created");
    },
    addVariation() {
      this.variations.push({
        text: "",
        type: "variation",
        loading: false,
        uid: null,
        created_at: null,
      });
      const vm = this;
      setTimeout(() => {
        vm.tab = vm.variations.length - 1;
      }, 150);
    },
    altImage() {
      this.media[0].src = this.media[0].alt[this.alt];
      if (this.alt === this.media[0].alt.length - 1) {
        this.alt = 0;
      } else {
        this.alt++;
      }
    },
    setPreview(v) {
      this.media = [
        {
          alt: v.images,
          type: "url",
          url: v.url,
          src: v.image,
          description: v.description,
          language: v.language,
          title: v.title,
        },
      ];
      this.sheet = false;
    },
    checkPost() {
      return new Promise((resolve) => {
        let complete = {
          pass: true,
          missing: [],
        };

        if (this.selected_accounts.length === 0) {
          complete.pass = false;
          complete.missing.push(
            "Please select at least one social media account",
          );
        }
        if (!this.category) {
          complete.pass = false;
          complete.missing.push("Please select a category");
        }
        if (this.recurring === null) {
          complete.pass = false;
          complete.missing.push("Please select if this post can be recurring.");
        }
        if (
          !this.media &&
          this.selected_accounts.find((a) => a.type === "instagram") !=
            undefined
        ) {
          complete.pass = false;
          complete.missing.push(
            "Please add an image. Instagram posts require an image, or remove the Instagram accounts from the list.",
          );
        }

        this.complete = complete;

        resolve(complete);
      });
    },
    clearPost() {
      if (this.post) {
        this.$router.replace("/post");
      }
      this.$store.dispatch("clearPost");
    },

    confirmResult(v) {
      this.confirm_dialog = false;
      if (v) {
        this.clearPost();
      }
    },
    confirm() {
      this.confirm_dialog = true;
    },
    enter(v) {
      if (v.code === "Enter") {
        this.link_step = 1;
        this.getPreview();
      }
    },
    formatDate(t) {
      let day = DateTime.fromMillis(t * 1000);
      return day.toFormat("ff");
    },
    insert(emoji) {
      if (!this.variations || !this.variations[this.tab]) return;

      const ref =
        this.$refs[`textarea-${this.tab}`][0].$el.querySelector("textarea");

      const cursor = ref.selectionStart;
      const start = this.variations[this.tab].text.substring(0, cursor);
      const end = this.variations[this.tab].text.substring(cursor);
      const text = start + emoji + end;

      this.variations[this.tab].text = text;
    },

    openMedia() {
      if (this.link_preview) {
        this.remove_link = true;
      } else {
        this.menu = false;
        this.$store.commit("setMediumType", `post`);
      }
    },

    removeLink(v) {
      if (v) {
        this.link_preview = null;
        this.$store.commit("setMediumType", `post`);
        this.idea = "";
        this.$refs.askChat.clear();
      }
      this.remove_link = false;
    },
    removeVariation(i) {
      this.variations.splice(i, 1);
      if (this.variations.length === 0) {
        this.variations.push({
          text: "",
          type: "main",
          loading: false,
          uid: null,
          created_at: null,
        });
      }
      if (this.tab === i || this.tab >= this.variations.length) {
        this.tab = this.variations.length - 1;
      }
    },
    schedule(v) {
      this.dialog = false;
      const now = DateTime.now();
      let day = DateTime.fromObject(
        {
          day: v.day,
          month: v.month,
          year: v.year,
          hour: v.hour,
          minute: v.minutes,
        },
        { zone: this.workspace.timezone },
      );

      if (day > now && !this.changing_schedule) {
        this.add(day.toSeconds(), "active");
      } else if (this.changing_schedule && day > now) {
        this.schedule_date = day.toSeconds();
        this.changing_schedule = false;
      } else {
        this.changing_schedule = false;
        this.dialog = true;
        this.$store.commit("setNotification", {
          show: true,
          text: "Scheduled time is in the past!",
          type: "error",
        });
      }
    },
    selectImage(v) {
      this.image = v.src.large2x;
    },
    selectPage(v) {
      if (this.channels.find((c) => c.id === v.id)) {
        this.channels.splice(
          this.channels.findIndex((c) => c.id === v.id),
          1,
        );
      } else {
        this.channels.push(v);
      }
    },

    setTemplate() {
      return new Promise((resolve) => {
        const getTemplate = httpsCallable(functions, "getTemplate");
        let url =
          "https://www.nu.nl/formule-1/6300370/red-bull-onderzoekt-mogelijk-grensoverschrijdend-gedrag-teambaas-horner.html";

        const res = getTemplate({
          url: url,
        });
        console.log(res.data);
        resolve();
      });
    },
    useContent(v, t) {
      return new Promise((resolve) => {
        console.log(v);
        let x = this.variations.find((v) => v.timestamp === t);

        if (!v.includes(" ")) {
          x.text = v;
          resolve();
        } else {
          let chunks = v.split(" ");

          x.text = "";
          for (let i = 0; i <= chunks.length - 1; i++) {
            setTimeout(function () {
              let space = i === 0 ? "" : " ";
              x.text = x.text.concat(space, chunks[i]);
              if (i + 1 === chunks.length) {
                x.timestamp = null;
                resolve();
              }
            }, 25 * i);
          }
        }

        this.ideas_drawer = false;
      });
    },
  },
};
</script>

<style scoped lang="scss">
:deep(.v-field) {
  font-size: 10pt !important;
}

@import "./styles.scss";
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
</style>
